import React from 'react';
import cn from 'classnames';

import styles from './SummaryStatus.module.scss';

interface ISummaryStatusProps {
    unresolved?: number;
    resolved?: number;
}

const SummaryStatus: React.FC<ISummaryStatusProps> = ({unresolved, resolved}) => {
    const unresolvedCount = unresolved ?? 0;
    const resolvedCount = resolved ?? 0;

    return (
        <div className={styles.container}>
            <span className={cn(styles.errorIncident, styles.count)}>{unresolvedCount}</span>
            <span className={cn(styles.decideIncident, styles.count)}>{resolvedCount}</span>
        </div>
    );
};

export default SummaryStatus;

